import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useQuery } from "seed/gql";
import { usePost } from "seed/api";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/presentation/forms/collaboration/AccessForm.view";


function Access({ roleOptions, flowId, onCompleteAccess }) {

  const userId = sessionStorage.getItem("id");
  const [activePanel, setActivePanel] = useState("email_panel");

  const [callSharePhones] = usePost("/flows/share_phones", {
    onCompleted: () => {
      onCompleteAccess();
    },
    onError: (err) => {
      console.log(err)
      swal("Error", l("Error al compartir el teléfono%PA013"), "error");
    }
  })

  const [callShareEmails] = usePost("/flows/share_emails", {
    onCompleted: () => {
      onCompleteAccess();
    },
    onError: (err) => {
      console.log(err)
      swal("Error", l("Error al compartir el correo electrónico%PA014"), "error");
    }
  })

  const [callShareOrganizations] = usePost("/flows/share_organizations", {
    onCompleted: () => {
      onCompleteAccess();
    },
    onError: (err) => {
      console.log(err)
      swal("Error", l("Error al compartir la organización%PA015"), "error");
    }
  });

  const reqOrganizations = useQuery(`{
    organizationParticipants {
      type  
      organization {
        name
        orgSettings
      }
    }
  }`, `user.id=${userId}`);

  useEffect(() => {
    reqOrganizations.refetch();
  }, []);

  const validatePhone = (phone) => {
    const phoneRegex = /^(\+?\d{1,3}[- ]?)?\d{10,15}$/;
    return phoneRegex.test(phone);
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const onCreateAccess = (values) => {

    const { organization, type, email, phone } = values;

    if (activePanel == "organization_panel") {
      if (!organization) {
        swal("Error", l("Debes seleccionar una organización%PA016"), "error");
        return false;
      }

      callShareOrganizations({
        organizations: [organization],
        send_invitation: values?.sent_email_org_invitation ?? false,
        role_id: type,
        flow_id: flowId
      });
    }

    if (activePanel == "email_panel") {
      if (!email) {
        swal("Error", l("Debes ingresar un correo electrónico%PA017"), "error");
        return false;
      }

      if (!validateEmail(email)) {
        swal("Error", l("El correo electrónico no es válido%PA018"), "error");
        return false;
      }

      callShareEmails({
        emails: [email],
        send_invitation: values?.send_email_invitation ?? false,
        role_id: type,
        flow_id: flowId
      });
    }

    if (activePanel == "phone_panel") {
      if (!phone) {
        swal("Error", l("Debes ingresar un teléfono%PA019"), "error");
        return false;
      }

      if (!validatePhone(phone)) {
        swal("Error", l("El teléfono no es válido%PA020"), "error");
        return false;
      }

      callSharePhones({
        phones: [phone],
        send_invitation: values?.sent_wa_invitation ?? false,
        role_id: type,
        flow_id: flowId
      });
    }

  }

  if (reqOrganizations.loading) return <Loading />;
  if (reqOrganizations.error) return "Error"

  const organizationsParticipants = reqOrganizations.data?.organizationParticipants ?? [];
  const organizations = organizationsParticipants.map((organizationsParticipant) => organizationsParticipant.organization);

  return (
    <View
      organizations={organizations}
      activePanel={activePanel}
      roleOptions={roleOptions}
      setActivePanel={setActivePanel}
      onCreateAccess={onCreateAccess}
    />
  );
}


export default Access;